/* ============
 * All Business Hours
 * ============
 *
 * All cities from a country.
 */

import Vue from 'vue';
import store from './../../store';
import businessHoursTransformer from './../../transformers/businessHour';

const success = ({ data }, resolve) => {
  const hours = businessHoursTransformer.fetchCollection(data.data);

  store.dispatch('fetchBusinessHours', hours);
  resolve();
};

const failed = () => {
};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('business_hours')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/businessHour/all.js